import styled from 'styled-components'
import { BigNumber } from '../../components'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 24px;
`

const BigNumberKPIList = ({ kpis }) => {
  const { t } = useTranslation('common')
  const bigNumberKPIs = {
    'Fatigue Index': {
      title: t('big_number_kpi.fatigue_index.title'),
      tooltip: t('big_number_kpi.fatigue_index.tooltip'),
    },
    'High Fatigue Count': {
      title: t('big_number_kpi.high_fatigue.title'),
      tooltip: t('big_number_kpi.high_fatigue.tooltip'),
    },
    'Sleep Average': {
      title: t('big_number_kpi.sleep_average.title'),
      tooltip: t('big_number_kpi.sleep_average.tooltip'),
    },
    'Caffeine Average': {
      title: t('big_number_kpi.caffeine_average.title'),
      tooltip: t('big_number_kpi.caffeine_average.tooltip'),
    },
    'Personal Fatigue Index': {
      title: t('big_number_kpi.personal_fatigue_index.title'),
      tooltip: t('big_number_kpi.personal_fatigue_index.tooltip'),
    },
  }
  return (
    <Container>
      {kpis?.map(
        ({
          title,
          kpi,
          type,
          comparison,
          textComparison,
          trendStyle,
          comparisonType,
        }) => {
          return (
            <BigNumber
              key={title}
              title={bigNumberKPIs[title]?.title}
              value={kpi}
              type={type}
              comparisonValue={comparison}
              comparisonDescription={textComparison}
              comparisonType={comparisonType}
              trendStyle={trendStyle}
              tooltip={bigNumberKPIs[title]?.tooltip}
            />
          )
        },
      )}
    </Container>
  )
}

export default BigNumberKPIList
